// In CourseReportService.js
import api from "Common/Client/Interceptor";

export const courseReportService = {
  // Get course report data
  getCourseReport: async (params) => {
    try {
      const response = await api.get(`/indv/reports/courses`, { params });
      console.log("Course report data response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching course report:", error);
      throw error;
    }
  },

  // Download course report as PDF
   downloadCourseReport: async (params) => {
    try {
      const response = await api.get(`/indv/reports/courses/download`, {
        params,
        responseType: "blob",
        headers: { Accept: 'application/pdf' },
      });
      console.log("response ....................after downloading ",response);
      return response; // This is already a blob
    } catch (err) {
      console.error("Error downloading course report:", err);
      throw err;
    }
  }
};